export const fail = 'FAIL';
export const success = 'SUCCESS';
